import { makeStyles } from "@fluentui/react-components";

export const useMenuStyles = makeStyles({
  portalAbove: {
    zIndex: 999,
  },
  portalBelow: {
    zIndex: 99999,
  },
});
